import { createSlice } from "@reduxjs/toolkit";
import * as API from "@vantiva-sa/spmrestclient/dist";
import { AppStorageKeys } from "../Constants/Constants";
import SessionStorage from "../Constants/SessionStorage";
import { getCurrentUserFromStorage } from "../Constants/Utilities";

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

const API_URL = ENV_VARS.API_URL;
const API_PORT = ENV_VARS.API_PORT;

const defaultClient = API.ApiClient.instance;
const headers = defaultClient.defaultHeaders;

const currentUser = getCurrentUserFromStorage();
if (currentUser && currentUser.access_token) {
  headers["Authorization"] = "Bearer " + currentUser.access_token;
}

const initialState = {
  serviceProviderApi: new API.ServiceProviderApi(),
  orderApi: new API.OrderApi(),
  SCMApi: new API.SCMApi(),
};

const apiStore = createSlice({
  name: "apis",
  initialState,
  reducers: {
    setBaseURL: (state, action) => {
      const apiURL = API_URL || action.payload;
      defaultClient.basePath = apiURL + ":" + API_PORT;
      defaultClient.timeout = 1800000; // api request client timeout - 30 mins
    },
    setAccessToken: (state, action) => {
      headers["Authorization"] = "Bearer " + action.payload;
    },
  },
});

export const { setBaseURL, setAccessToken } = apiStore.actions;

export default apiStore.reducer;
